import React from 'react';
const cellValue = (classification, clauseSource) => {
    if (clauseSource === undefined)
        return '';
    const checklistItem = clauseSource.checkList[classification.descriptor.key];
    if (!checklistItem)
        return '';
    return checklistItem.answer + ' ' + checklistItem.supportingText;
};
const cellValueFormatted = (classification, checklistItems) => {
    const checklistItem = checklistItems[classification.descriptor.key];
    if (!checklistItem)
        return React.createElement(React.Fragment, null);
    return React.createElement(React.Fragment, null,
        React.createElement("b", null, checklistItem.answer),
        React.createElement("br", null),
        React.createElement("br", null),
        checklistItem.supportingText.split('\n').map(i => React.createElement(React.Fragment, null,
            i,
            React.createElement("br", null))));
};
const modalValueFormatted = (classification, clauseSource) => {
    if (clauseSource === undefined)
        return React.createElement(React.Fragment, null);
    const checklistItem = clauseSource.checkList[classification.descriptor.key];
    if (!checklistItem)
        return React.createElement(React.Fragment, null);
    return React.createElement(React.Fragment, null,
        React.createElement("b", null, checklistItem.answer),
        React.createElement("br", null),
        React.createElement("br", null),
        checklistItem.supportingText.replaceAll('\n', ' '));
};
export default { cellValue, cellValueFormatted, modalValueFormatted };
